export default {
  default : 'solid',
};
